import React from 'react';
import { useDispatch  } from 'react-redux';
import { useInfiniteQuery } from 'react-query';
import { addAlert } from '../../actions/alerts.action';
import { fetchGroupObjectives } from '../../api/objective/objective.api';
import { formatDateString } from '../../utils/dates';
import ObjectiveList from './ObjectiveList';
import { useFilterContext } from '../Filters/FilterProvider';

const GroupObjectives = () => {
  const dispatch = useDispatch();

  const {
    statusFilters,
    developmentStatusFilters,
    categoryFilters,
    dateRange
  } = useFilterContext();

  const objectivesQuery = useInfiniteQuery(
    [ 'objectives', statusFilters, developmentStatusFilters, categoryFilters, dateRange ],
    async ({ pageParam = 0 }) => {
      const { data } = await fetchGroupObjectives({
        offset: pageParam,
        filters: {
          statuses: statusFilters || '',
          developmentStatuses: developmentStatusFilters || '',
          categories: categoryFilters || '',
          dateStart: dateRange.from ?
            new Date(formatDateString(dateRange.from))?.toISOString() :
            null,
          dateEnd: dateRange.to ?
            new Date(formatDateString(dateRange.to))?.toISOString() :
            null
        }
      });
      return data;
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        return lastPage?.length ? allPages?.flat().length : undefined;
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const objectives = objectivesQuery.data?.pages.flat() ?? [];

  return (
    <ObjectiveList
      objectives={ objectives }
      loading={ objectivesQuery.isFetching }
      onSubmitSuccess={ objectivesQuery.refetch }
      canLoadMore={ objectivesQuery.hasNextPage }
      loadMore={ objectivesQuery.fetchNextPage }
      showGroupColumns
    />
  );
};

export default GroupObjectives;
